.wrapper {
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	color: #374151;
	--cf-primary: #7fb02f;
}

.center {
	grid-column: 1 / -1;

	display: grid;
	place-items: center;

	width: 100%;

	min-height: 220px;
	text-align: center;
	grid-auto-flow: row;
}

.sm {
	--cf-size: 16px;
}
.md {
	--cf-size: 20px;
}
.lg {
	--cf-size: 28px;
}

.spinner {
	width: var(--cf-size, 20px);
	height: var(--cf-size, 20px);
	border-radius: 50%;
	border: 2px solid #e5e7eb;
	border-top-color: var(--cf-primary, #7fb02f);
	animation: cf-spin 0.8s linear infinite;
}

.text {
	font-size: 0.95rem;
	color: #6b7280;
}
.center .text {
	margin-top: 0.35rem;
}

@keyframes cf-spin {
	to {
		transform: rotate(360deg);
	}
}
